import PropTypes from 'prop-types'

const { array, bool, number, shape, string } = PropTypes

export default shape({
    tags: array,
    rating: string,
    sourceUrl: string,
    termsAgreed: bool,
    username: string,
    channelId: number,
    isPrivate: bool,
})
